import { FormControl, ValidatorFn, AbstractControl } from '@angular/forms';
export function passwordMatchValidator(AC: AbstractControl): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const pass = AC.get('password');
    const confirm = AC.get('confirmPassword');
    if (
      pass &&
      pass.value &&
      confirm &&
      confirm.value &&
      pass.value === confirm.value
    ) {
      return null;
    }
    return { passwordMatch: true };
  };
}
